import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { boardMemberApi } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export const JoinBoard: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [boardTitle, setBoardTitle] = useState<string>('');

  useEffect(() => {
    if (user && token) {
      handleJoinBoard();
    }
  }, [user, token]);

  const handleJoinBoard = async () => {
    if (!token) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await boardMemberApi.acceptInviteLink(token);
      setBoardTitle(response.data.board.title);
      setSuccess(true);
      
      // Rediriger vers le tableau après 2 secondes
      setTimeout(() => {
        navigate(`/boards/${response.data.board.id}`);
      }, 2000);
    } catch (err: any) {
      if (err.response?.status === 404) {
        setError('Ce lien d\'invitation est invalide ou a expiré.');
      } else if (err.response?.data?.message?.includes('déjà membre')) {
        setError('Vous êtes déjà membre de ce tableau.');
        // Rediriger quand même vers le tableau
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        setError(err.response?.data?.error || 'Erreur lors de l\'acceptation de l\'invitation.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="join-board-page">
        <div className="join-board-container">
          <div className="join-board-card">
            <h1>Invitation à rejoindre un tableau</h1>
            <p>Vous devez être connecté pour accepter cette invitation.</p>
            <div className="join-board-actions">
              <button
                className="btn btn-primary"
                onClick={() => navigate('/login', { state: { returnTo: `/join/${token}` } })}
              >
                Se connecter
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/register', { state: { returnTo: `/join/${token}` } })}
              >
                Créer un compte
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="join-board-page">
      <div className="join-board-container">
        <div className="join-board-card">
          {isLoading ? (
            <>
              <div className="join-board-spinner"></div>
              <h2>Acceptation de l'invitation...</h2>
              <p>Veuillez patienter</p>
            </>
          ) : success ? (
            <>
              <div className="join-board-success">✓</div>
              <h2>Bienvenue !</h2>
              <p>Vous avez rejoint le tableau <strong>{boardTitle}</strong> avec succès.</p>
              <p className="join-board-redirect">Redirection en cours...</p>
            </>
          ) : error ? (
            <>
              <div className="join-board-error">✕</div>
              <h2>Erreur</h2>
              <p>{error}</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard')}
              >
                Retour aux tableaux
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
